import Flickity from "flickity";

class CustomNav {
	constructor(config) {
		this.config = Object.assign({
			flickity: null,
			scope: null,
			dot: '.dot',
			prev: '[data-flickity-nav="prev"]',
			next: '[data-flickity-nav="next"]',
			templatedot: '[data-flickity-dot="template"]'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.updateDotsAndButtons(this.config.flickity.selectedIndex);
		this.addEventListeners();
		this.initDots();
	}

	initDots() {
		this.$scope.each((index, element) => {
			let $scope = $(element);
			$scope.find(this.config.dot + '[data-keep="false"]').remove();
			let slider = Flickity.data(($scope.find('.flickity-carousel'))[0])
			let $template = $scope.find(this.config.templatedot);
			let $dots = $scope.find('.dots');
			for (let i = 0; i < slider.slides.length; i++) {
				let $dot = $template.clone();
				if (i == slider.selectedIndex) {
					$dot.addClass('active');
				}
				$dot.removeClass('d-none');
				$dot.data('flickity-dot', i);
				$dot.attr('flickity-dot', i);
				$dot.attr('data-keep', 'false');
				$dots.append($dot);
			}
		});

	}

	updateDotsAndButtons(index) {
		this.$scope.find(`${this.config.prev}, ${this.config.next}`).removeClass('disabled');
		this.$scope.find(this.config.dot).removeClass('active');
		if (index <= 0) {
			this.$scope.find(this.config.prev).addClass('disabled');
		}
		if (index >= this.config.flickity.slides.length - 1) {
			this.$scope.find(this.config.next).addClass('disabled');
		}
		this.$scope.find(`${this.config.dot}[flickity-dot="${index}"]`).addClass('active');
	}

	addEventListeners() {
		this.$scope.on('click', this.config.next, this.next.bind(this));
		this.$scope.on('click', this.config.prev, this.prev.bind(this));
		this.$scope.on('click', this.config.dot, this.setSlideIndexByDot.bind(this));
		this.config.flickity.on('change', this.updateDotsAndButtons.bind(this));
	}

	next(event) {
		event.preventDefault();
		this.config.flickity.next();
	}

	prev(event) {
		event.preventDefault();
		this.config.flickity.previous();
	}

	setSlideIndexByDot(event) {
		event.preventDefault();
		this.setSlideIndex($(event.currentTarget).data('flickity-dot'));
	}

	setSlideIndex(index) {
		this.config.flickity.select(index);
	}
}

export default CustomNav;